import {
  Box,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { ButtonCust, CustToolTip } from "../../../widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./S6_InitialActivation.module.scss";
import { ActivationStatus, CustomerStatus } from "../../../../enums";
import Config from "../../../../config/env.config.json";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { InternalBanner } from "../../../common/InternalBanner";
import ImeiLookUpComponent from "./ImeiLookUpComponent";
import { useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { SimTypes } from "../../../../features/checkout/Types";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
const T6_InitialActivation = (props: any) => {
  const { handleStep, currentLine, content, updatingCustomer } = props;
  const { extraLines } = currentLine;
  const letsGoHandler = () => {
    if (currentLine?.esim) {
      updatingCustomer({
        activationJourneyStatus: ActivationStatus.IN_PROGRESS,
      });
    }
    handleStep(true);
  };
  const {
    intro_title,
    intro_desc1,
    intro_desc11,
    intro_desc12,
    intro_desc2,
    intro_pnts,
    intro_btn,
    tick_icon,
    esim_points,
    each_icon,
    flight_icon,
    infoData,
  } = content || {};
  const noOfLines = extraLines + 1;
  let introPoints;
  let EsimLine =
    currentLine?.esim || currentLine?.simPreference === SimTypes?.ESIM;

  if (content?.how_find_txt) {
    if (EsimLine) {
      introPoints = currentLine?.isPrimary ? esim_points : intro_pnts;
    } else {
      introPoints = infoData;
    }
  } else {
    if (EsimLine) {
      introPoints = esim_points;
    } else {
      introPoints = infoData;
    }
  }

  const disableBack =
    currentLine?.isSimInHand &&
    currentLine?.isPrimary &&
    !Config?.IS_APN_SETTINGS_DETAILS_SCREEN_NEEDED;
  let customer: any = localStorage.getItem("customerDetail");
  customer = customer ? JSON.parse(customer) : null;
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <>
      {/* <InternalBanner
        // key={key}
        pageName={"MyAccount"}
        apiEndPoint={"myAccBanner"}
        type={"internal"}
      /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          background: "var(--lightgrey)",
          height: "fit-content",
          minHeight: "88vh",
        }}
      >
        <Box
          display={{ xs: "none", md: "block" }}
          sx={{
            cursor: disableBack ? "not-allowed !important" : "pointer",
            opacity: disableBack && "0.5",
            width: "24px",
            height: "24px",
            zIndex: "100",
            left: "0",
            position: "absolute",
            ml: { md: "30px", sm: "25px", xs: "25px" },
            mt: { md: "60px" },
            display: { xs: "none", sm: "inline-block" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "18px",
              height: "18px",
              position: "absolute",
              left: "3rem",
              alignItems: "center",
            }}
            onClick={() => (disableBack ? null : handleStep(false))}
          >
            <ArrowBackIosIcon sx={{ width: "18px", fontSize: "1.125rem" }} />
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_1)",
                fontSize: "18px",
                lineHeight: "30px",
              }}
            >
              Back
            </Box>
          </Box>
        </Box>
        <KeyboardBackspaceIcon
          onClick={() => (disableBack ? null : handleStep(false))}
          fontSize="large"
          sx={{
            display: { xs: "block", sm: "none" },
            position: "absolute",
            top: "92px",
            left: "20px",
            color: "var(--internal_back_arrow_color)",
          }}
        />
        <Paper
          sx={{
            // border: "1px solid rgba(0,0,0,.2)",
            width: {
              xs: "90%",
              sm: content?.ip_here_how_find ? "652px" : "724px",
            },
            height: "fit-content",
            paddingBottom: { xs: "30px", sm: "45px" },
            mt: { xs: "40px", sm: "60px" },
            boxShadow: { xs: "unset !important" },
            marginBottom: "100px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              p: { xs: "25px 0px" },
            }}
          >
            {/* <Box
              component="img"
              alt={"circular_loader"}
              src={flight_icon?.data?.[0]?.attributes?.url}
              sx={{ width: { xs: "33px", paddingRight: "16px" } }}
            /> */}
            <Typography
              sx={{
                fontSize: { xs: "18px", sm: "24px" },
                fontFamily: "var(--font_family_Bold)",
                textAlign: "center",
                fontWeight: "var(--font_weight_4)",
                color: "var(--black)",
                lineHeight: { xs: "30px", sm: "36px" },
              }}
            >
              {intro_title}
            </Typography>
          </Box>
          <Box sx={{ width: "100%", textAlign: "center" }}>
            <Divider
              style={{ border: "1px solid var(--lightgrey_6)" }}
            ></Divider>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              sx={{
                fontSize: "18px",
                color: "var(--text_color)",
                fontFamily: "var(--font_family_Semibold)",
                mt: { xs: "18px" },
                mb: { xs: "21px" },
              }}
            >
              {intro_desc2}
            </Typography>
          </Box>
          <Box
            sx={{
              mx: EsimLine ? "" : "auto",
              width: content?.ip_here_how_find
                ? {
                    xs: EsimLine ? "auto" : "100%",
                    md: EsimLine ? "auto" : "70%",
                  }
                : EsimLine
                ? "auto"
                : "60%",
            }}
          >
            {introPoints?.map((data: any) => {
              return (
                <Box
                  className={
                    content?.ip_here_how_find
                      ? styles.activation_info_next
                      : styles.activation_info
                  }
                  key={data.id}
                  sx={{
                    px: { xs: "30px", md: EsimLine ? "65px" : "55px" },
                    boxSizing: "border-box",
                  }}
                >
                  {/* <img
                    className={
                      content?.ip_here_how_find
                        ? styles.check_icon_next
                        : styles.check_icon
                    }
                    src={each_icon?.data?.[0]?.attributes?.url}
                    alt={each_icon?.data?.[0]?.attributes?.alternativeText}
                  /> */}
                  <ArrowCircleRightOutlinedIcon
                    className={styles.check_icon}
                    sx={{ color: "var(--primary_color)" }}
                  />
                  <Typography
                    className={styles.activation_body_text}
                    sx={{
                      fontSize: "16px !important",
                      color: "var(--davys-grey)",
                      wordWrap: "break-word !important",
                      maxWidth: "100%",
                      textAlign: content?.ip_here_how_find
                        ? "start !important"
                        : "initial",
                      flexDirection: content?.ip_here_how_find
                        ? { xs: "column", md: "row" }
                        : "row",
                    }}
                  >
                    {BrandNameUpdate(data.desc)}
                    {data?.here_how_find && (
                      <>
                        <ClickAwayListener onClickAway={() => setOpen(false)}>
                          <CustToolTip
                            className={styles.customTooltip}
                            arrow
                            open={open}
                            disableFocusListener
                            disableHoverListener
                            title={
                              <ImeiLookUpComponent
                                isTitle={false}
                                content={props?.content?.imei_look_up}
                              />
                            }
                          >
                            <Typography
                              sx={{
                                cursor: "pointer",
                                fontFamily: "var(--font_family_Medium)",
                                fontWeight: "500",
                                color: "var(--primary_color)",
                                marginTop: { xs: "0px", md: "2px" },
                                marginLeft: { xs: "-4px", md: "0px" },
                                paddingTop: { xs: "5px", md: "0px" },
                              }}
                              onMouseEnter={() => {
                                setOpen(true);
                              }}
                              onMouseLeave={() => {
                                setOpen(false);
                              }}
                              onClick={handleTooltipOpen}
                            >
                              &nbsp;{content?.how_find_txt}
                            </Typography>
                          </CustToolTip>
                        </ClickAwayListener>
                      </>
                    )}
                  </Typography>
                </Box>
              );
            })}
          </Box>
          <Box sx={{ textAlign: "center", mt: "27px", mb: "6px" }}>
            <ButtonCust
              variantType={Config.PRIMARY_BUTTON_TYPE}
              onClick={() => letsGoHandler()}
              sx={{
                width: { xs: "250px" },
                // width: { xs: "250px", sm: "250px", md: "250px" },
                // height: { md: "50px !important" },
              }}
            >
              {intro_btn}
            </ButtonCust>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default T6_InitialActivation;
